import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
const POLL_MS = 30000;

// Live / final scores for bet games around today, keyed by game id.
// Polls while the tab is visible; the backend caches the provider.
export function useLiveScores() {
  const [games, setGames] = useState({});

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (document.visibilityState === 'hidden') return;
      try {
        const response = await fetch(`${API_URL}/live-scores/`);
        if (!response.ok) return;
        const data = await response.json();
        if (!cancelled) setGames(data.games || {});
      } catch {
        // No live data is fine: cards just show the fixture as before
      }
    }

    load();
    const interval = setInterval(load, POLL_MS);
    document.addEventListener('visibilitychange', load);
    return () => {
      cancelled = true;
      clearInterval(interval);
      document.removeEventListener('visibilitychange', load);
    };
  }, []);

  return games;
}
